import { IdentityAvatarBase, IdentityAvatarProps } from './IdentityAvatarBase';

export const IdentityAvatar = (props: IdentityAvatarProps) => (
  <IdentityAvatarBase
    {...props}
    avatarSrc={props.identityRef?.pictureUri || undefined}
  />
);
